module.exports = __webpack_public_path__ + "img/20180815_151538_163.bc5c7790.jpg";